import $ from "jquery";
import "./styles/eventpage.scss";

export class EventPage {

    constructor() {
        this.init();
    }

    private init(): void {

    }

    public onShow?: () => void;

    public onClose?: () => void;

    private loadContent(): void {
        if (this.isDivEmpty("player")) {
            this.hideElement("playerContainer");
        }


        if (this.isDivEmpty("poll")) {
            this.hideElement("pollContainer");
        }

        if (this.isDivEmpty("chat")) {
            this.hideElement("chatContainer");
        }
    }

    /*
     * Checks if the div element is empty, assuming, that it is empty, if it has no children.
     * Since in our case the divs contain iFrames, checking for child elements should cover the cases.
     */
    private isDivEmpty(elementId: string): boolean {
        if ($(`#${elementId}`).children().length > 0) {
            return false;
        }
        return true;
    }

    private hideElement(elementId: string): void {
        $(`#${elementId}`).hide();
    }

    public check(): void {
        this.loadContent();
    }
}